export default function cls(...classnames) {
  return classnames.join(" ");
}
